module.exports = __webpack_public_path__ + "img/veusinho.77d475a5.png";